/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

import { SFCommunicationHelper } from "../helpers";
import { IModalData } from "../interfaces";

/**
 * Custom hook to manage modal popup interactions with the SFCommunicationHelper.
 * @param {Function} setIsPrimaryButtonClicked - useState function to update the primary button click state.
 */
const useIBModalPopup = (setIsPrimaryButtonClicked: any) => {
  const sfCommunicationHelper = new SFCommunicationHelper();

  /**
   * Shows the modal popup using the provided modal data.
   * @param {IModalData} modalData - The data to display in the modal popup.
   */
  const showModalPopup = (modalData: IModalData): void => {
    sfCommunicationHelper.showModal(modalData);
  };

  /**
   * Handles the "onShowModalCallbackEvent" event and updates the primary button click state.
   * @param {any} event - The event object containing the detail of the primary button clicked OR not.
   */
  const handleOnShowModalCallbackEvent = (event: any): void => {
    setIsPrimaryButtonClicked(!!event.detail);
  };

  /**
   * Adds the "onShowModalCallbackEvent" event listener on mount and removes it on unmount.
   */
  useEffect(() => {
    window.addEventListener(
      "onShowModalCallbackEvent",
      handleOnShowModalCallbackEvent
    );

    return () => {
      window.removeEventListener(
        "onShowModalCallbackEvent",
        handleOnShowModalCallbackEvent
      );
    };
  }, []);

  return { showModalPopup };
};

export default useIBModalPopup;
